const messages = {
  availPoints: "Dostupni bodovi",
  awaitingPoints: "Bodovi na čekanju",
  board: {
    title: "Nadzorna ploča",
    title2: "Učinak promocije {year}",
    headline1: "Vaše promocije i bodovi na prvi pogled",
    headline2: "Skupljajte bodove za kupnju guma.",
    pointsBalanceToDate: "STANJE BODOVA NA DAN",
    availPoints: "Dostupni bodovi",
    awaitingPoints: "Bodovi na čekanju",
    yourRealisation: "VAŠI REZULTATI",
    yourEngagement: "Vaš godišnji cilj: <b>{tyres} guma</b>",
    yourPoints: "VAŠI BODOVI",
    yourRetailPurchase: "VAŠE KUPOVINE U DETALJIMA",
    yourRetailPurchaseCCS: "VAŠA PRODAJA U DETALJIMA",
    pointsByPurchase: "bodovi ostvareni kupnjom",
    pointsByBoosters: "bodovi ostvareni boosterima",
    pointsByBSPurchase: "Bodovi ostvareni kupnjom kod Bridgestonea",
    pointsByBSPurchaseCCS: "Bodovi ostvareni prodajom Bridgestone guma",
    remaining: "Preostale gume",
    yourGoal: "Napredak prema cilju",
    unit: "gume",
    buttons: {
      learnMore: "Saznajte više o svojim bodovima",
      learnMoreAboutMechanism: "Saznajte više o mehanizmu",
    },
    charts: {
      byBrand: "Po marki",
      bySize: "Po veličini<br/>naplatka",
    },
    exploreResults: "Istražite svoje rezultate",
    tyreLimitInfo:
      "Za svako razdoblje Booster akcije potreban je minimalni sell-out od 50 Bridgestone i/ili Firestone guma.",
  },
  charts: {
    byBrand: "Po marki",
    bySize: "po veličini naplatka",
  },

  dashboard: {
    dashboardTitle: "Vaše pogodnosti",
    dashboardBox: {
      title: "Stanje bodova",
      description: "Trenutni broj vaših marketinških bodova",
      availPoints: "Dostupni bodovi",
      awaitingPoints: "Bodovi na čekanju",
      lastUpdate: "Zadnje ažuriranje",
      button: "Saznajte više",
      points: "bodovi",
    },
  },
  soldTyres: "PRODANE GUME",
  receivedPoints: "OSVOJENI BODOVI",
  boosterCCS: {
    personalInfo: "Osobni podaci",
    csNumberTitle: "Navedite broj(eve) sudjelujućih računa",
    tyresTitle: "Navedite broj prodanih guma",
    minTyresInfo:
      "Potreban je minimum od {tyres} Bridgestone/Firestone guma. Nagrada se obračunava samo za Bridgestone gume.",
    tyresAmount: "Broj guma",
    filesTitle: "Prenesite dokaz(e) o prodaji",
    filesDescription:
      "Napomena: uvažavaju se samo prodaje koje sadrže dimenziju naplatka gume.",
    addAnotherFile: "Dodaj dokument",
    file: "Prenesi dokument",
    formatInfo:
      "Podržani formati datoteka: xlsx, jpeg i pdf. Maksimalna veličina datoteke: 8 MB",
    confrimationMessage:
      "<b>Hvala na sudjelovanju!</b> <br/>Vaš zahtjev je zaprimljen i proslijeđen Bridgestone timu na provjeru.<br/>O rezultatima sudjelovanja u Booster CCS akciji bit ćete obaviješteni e-poštom.<br/>Vidimo se uskoro na Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Podijelite bodove",
    forShare: "Bodovi koje dijelite",
    title: "Naslov",
  },
  notFoundFile: "Nije odabrana datoteka",
  chooseFile: "Odaberite datoteku",
};

export default {
  messages,
};
